<template>
  <div id="About">
    <div class="banner">
      <img src="/static/images/about/ab_bg.png" alt="">
      <div class="bannerText">
        <div class="title">{{$t("about.bannerText")}}</div>
        <div class="titleSub">{{$t("about.bannerDetail")}}</div>
      </div>
    </div>
    <div class="content">
        <div class="con">
            <div class="box">
                <div class="boxCon">
                  <div class="imgBox">
                    <img src="/static/images/about/ab_hk.png" alt="">
                  </div>
                  <div class="detail">
                    <div class="title">{{$t("about.tit")}}</div>
                    <p>
                   {{$t("about.detail1")}}
                    </p>
                    <br>
                    <p>
                    {{$t("about.detail2")}}
                    </p>

                      <br>
                      <p>
                          {{$t("about.detail3")}}
                      </p>
                      <br>
                      <p>
                          {{$t("about.detail4")}}
                      </p>
                  </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {

    };
  },
  //定义这个sweiper对象
  computed: {},
  created:function () {
    window.scroll(0, 0);
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
    if (this.$getCookie("langs") == "en") {
      this.lang_en = true;
    } else {
      this.lang_en = false;
    }
    this.show=true
  },
  methods: {

  }
};
</script>
<style lang="less" type="text/less">
  .el-input__inner{
    background: #f7f7f7;
    color: #999
  }
  .el-input__inner:focus{
    border-color: #27C2B4;
  }
</style>
<style scoped lang="less" type="text/less">
#About{
  margin-top: 65px;
  .banner{
    position: relative;
    img{
      width: 100%;
    }
    .bannerText{
      position:absolute;
      top: 40%;
      left: 0;
      right: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      .title{
        font-size: 40px;
        font-weight: bold;
        position: relative;
        padding-right: 40px;
        &::before{
          content:'';
          display: inline-block;
          height: 38px;
          width: 3px;
          background: #e2e2e2;
          position: absolute;
          right: 0;
          bottom: 7px;
        }
      }
      .titleSub{
        padding-left: 30px;
        font-size: 20px;
        max-width: 600px;
      }
    }
  }
  .content{
    padding: 60px 0;
    min-height: 400px;
    .con{
      width: 60%;
      margin: 0 auto;
      .box{
        .boxCon{
          display: flex;
          justify-content: space-between;
          align-items:flex-start;
          position: relative;
          .imgBox{
            width: 40%;
            max-width: 320px;
            margin-right: 50px;
            img{
              width: 100%;
              max-width: 320px;
            }
          }
          .detail{
            width: 100%;
            font-size: 18px;
            color: #333;
            line-height: 28px;
            .title{
              font-size: 28px;
              color: #333;
              font-weight: bold;
              padding-bottom: 20px;
            }
          }
          &::before{
            content:'';
            display: inline-block;
            height: 1px;
            width: 100%;
            background: #e2e2e2;
            position: absolute;
            bottom: -35px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/About/About.vue